import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// const firebaseConfig = {
//   apiKey: 'AIzaSyA_Emc7nAMDRuBRmJJaDeT-XMXnV2pf3Ss',
//   authDomain: 'markethub-70f1a.firebaseapp.com',
//   databaseURL: 'https://markethub-70f1a-default-rtdb.firebaseio.com',
//   projectId: 'markethub-70f1a',
//   storageBucket: 'markethub-70f1a.appspot.com',
//   messagingSenderId: '146001622616',
//   appId: '1:146001622616:web:ba5b06b8b4bb6f6e15bc2d',
//   measurementId: 'G-HV1KXJB8WG'
// };

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC_WXsJMlWR6M22_jmNYkH0Sb8k2BEQ_GM",
  authDomain: "markethub-70f1a.firebaseapp.com",
  databaseURL: "https://markethub-70f1a-default-rtdb.firebaseio.com",
  projectId: "markethub-70f1a",
  storageBucket: "markethub-70f1a.appspot.com",
  messagingSenderId: "146001622616",
  appId: "1:146001622616:web:3511fe39bb039f9915bc2d",
  measurementId: "G-Q1KSDKBHVQ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// 🔐 App Check (site key is public; set REACT_APP_RECAPTCHA_SITE_KEY at build time)
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
if (!recaptchaSiteKey) {
  throw new Error(
    'Missing REACT_APP_RECAPTCHA_SITE_KEY. Add it to .env locally or as a GitHub Actions secret before building.'
  );
}

export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(recaptchaSiteKey),
  isTokenAutoRefreshEnabled: true,
});


export function getUserDisplayName(user) {
  if (!user) return '';
  if (user.displayName) return user.displayName;
  if (user.email) {
    const local = user.email.split('@')[0];
    return local.charAt(0).toUpperCase() + local.slice(1);
  }
  return 'User';
}
